/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
import React from 'react';

export function mergeRefs<T>(
  ...refs: Array<React.Ref<T> | undefined>
) {
  return (value: T | null) => {
    refs.forEach((ref) => {
      if (!ref) return;

      if (typeof ref === 'function') {
        ref(value);
      } else {
        (ref as React.MutableRefObject<T | null>).current = value;
      }
    });
  };
}
